// extracted by mini-css-extract-plugin
export default {"main":"MyProfileUpdateLayout_main__2tTOo","container":"MyProfileUpdateLayout_container__9nt7Z"};